import SortArrow from './sort-arrow';

export default SortArrow;
